import { Box, Typography } from "@mui/material";
import React from "react";
import defaultBanner from "../../assets/images/defaultBannerImage.png";
import defaultTeamLogo from "../../assets/images/defaultTournamentLogo.png";

const TournamentHeader = ({ data }) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${data?.bannerImage || defaultBanner})`,
        position: "relative",
        height: "24rem",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        padding: "2rem",
        display: "flex",
        objectFit: "contain",
        alignItems: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 1,
        },
      }}
    >
      {/* <Box sx={{ display: "flex", gap: "1rem" }}>
        <Box
          sx={{
            backgroundImage: `url(${data?.logo || defaultTeamLogo})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            height: "9rem",
            width: "9rem",
            borderRadius: "0.5rem",
            zIndex: 2,
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: ".5rem",
            zIndex: 2,
          }}
        >
          <Typography
            sx={{ color: "white", fontSize: "1.5rem", fontWeight: "500" }}
          >
            {data?.name}
          </Typography>
          <Typography sx={{ color: "white", fontSize: "1.2rem" }}>
            {data?.groundId?.name}
          </Typography>
          <Typography sx={{ color: "white", fontSize: "1rem" }}>
            {data?.city?.name},{data?.city?.stateName}
          </Typography>
        </Box>
      </Box> */}
    </Box>
  );
};

export default TournamentHeader;
